import { searchBox } from 'instantsearch.js/es/widgets'
import { getInstance, registerWidget } from './algolia-create-instance';

function initSearchBoxWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded)
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON)

  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaData.localized;

  // Get all elements with search bar class
  const elements = document.querySelectorAll("[data-filter-type='searchBox']")
  const elementsArray = Array.from(elements);

  // Group together search bar elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id')
        const placeholder = tgblAlgoliaData[widgetID]['search_box_placeholder']

        let AlgoliaSearchBar = ($, search, element) => {
          search.addWidgets([
            searchBox({
              container: element,
              placeholder: placeholder,
              cssClasses: {
                root: '',
                form: '',
                input: '',
                reset: ['tgblAlgolia-button', 'tgblAlgolia-button--is-theme-secondary'],
                resetIcon: '',
                loadingIndicator: '',
                loadingIcon: '',
                submit: 'tgblAlgolia-button',
                submitIcon: ''
              },
              templates: {
                submit ({cssClasses}, {html}) {
                  return `Search`
                }
              }
            })
            
          ]);
          registerWidget(element);
        };
        AlgoliaSearchBar($, search, element);
      });
    }
  }
}

export { initSearchBoxWidget }